/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import data from '../../data/rating'
import { ImageCover } from 'components/cover'
import { Introduction } from 'components/introduction'
import posterImage from 'images/cover-landscape.jpg?sizes[]=640w&sizes[]=1280w&sizes[]=1800w&sizes[]=2360w&placeholder'
import portraitPosterImage from 'images/cover-portrait.jpg?sizes[]=640w&sizes[]=1280w&sizes[]=1800w&sizes[]=2360w&placeholder'
import { Ranking } from 'components/ranking'

// TODO Set the correct article ID here
const ARTICLE_ID = '938674918226'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} inverted mediaName='sonntagszeitung' />
      <ThemeSwitch />

      <ImageCover
        inverted
        poster={posterImage}
        title='Die 75 besten Winterhotels der Schweiz'
        subtitle='Zum elften Mal präsentiert die SonntagsZeitung das grosse Rating des Hotelexperten Karl Wild.'
        coverHeight='calc(100vh - 4ex)'
        position='top'
        padding='calc(40px + 6%)'
        mobilePadding='calc(40px + 6%)'
        verticalPosition='left'
        verticalPadding='0%'
        showTextShadow={false}
        showTopGradient
        portraitPoster={portraitPosterImage}
        caption='Grüsst von der Spitze: The Chedi Andermatt'
      />

      <Introduction />

      <div className='ui container' style={{ marginTop: '2rem' }}>
        <div className='ui bottom pointing large blue basic label'>
          Wählen Sie eine Kategorie
        </div>
      </div>

      <Ranking rankingTable={data.data} />

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        credits={[
          ['Hotelranking und Texte', 'Karl Wild'],
          ['Digitale Umsetzung', 'Patrick Vögeli, Kaspar Manz']
        ]}
        mediaName='sonntagszeitung'
        fullMediaName='SonntagsZeitung'
        hidePortfolioTeaser
        hideUserFeedback
        topHalfClassName='grey'
      />
    </div>
  )
}
